<template>
  <div>
    <h3>Send a certificate to your phone</h3>
    <p>Make sure your certificate is password protected before uploaading it. You will need that password later  </p>
    <div  >
    <dropzone v-show="!canshowqr" 
      id="drop1"
      url="https://httpbin.xxxorg/post"
      v-on:vdropzone-file-added="fileAdded"
      :options="dropzoneOptions"
    :useCustomSlot=true>
      <div class="dropzone-custom-content">
        <h3 class="dropzone-custom-title">Drag and drop a p12 or pfx file to upload </h3>
        <div class="subtitle">...or click to select a file from your computer</div>
      </div>
    </dropzone>
    </div>
              <mdb-btn class="btn btn-primary" color="primary" v-show="canshowbutton" type="submit" @click="uploadcertfile" >Upload Now</mdb-btn>
  <vue-qrcode :value=urlfile v-show="canshowqr"  errorCorrectionLevel="low" />

    <div
      class="d-flex justify-content-center mb-3 modal "
      style="padding-top:300px"
      v-if="isLoading"
    >
      <spinner label="Loading..." style="width: 3rem; height: 3rem;"></spinner>
    </div>

  </div>
</template>

<script>
  import Dropzone from 'vue2-dropzone'
  import axios from 'axios'
import VueQrcode from 'vue-qrcode'
import Spinner from "../components/Spinner.vue";

  export default {
    name: 'UploadCert',

  data: function () {
    return {
              isLoading: false,
      evento: {},
      urlfile: "",
      canshowqr: false,
      canshowbutton:false,
      modal0:false,
      modal1:false,
      filedata:{},
      inputs: {
        fileSingle: [],
        fileMultiple: [],
      },
      readerpdf: "",
      readerpdfadic: "",
      readerxls: "",
      currentPage: 0,
      pageCount: 0,
      page: 1,
      rotate: 0,
      progress:0,

      dropzoneOptions: {
          url: 'https://httpbin.orgxx/post',
          thumbnailWidth: 150,
          maxFilesize: 0.5,
          headers: { "Authentication": "header value" },
          acceptedFiles:[".p12",".pfx"],
          

      },
           qrcodeOptions: {
             version: 21
           }


    }
  },

    components: {
      Dropzone,
      VueQrcode,
      Spinner
    },
    methods: {
      'showSuccess': function (file) {
        console.log('A file was successfully uploaded')
      },
  fileAdded(file) {
      let vv = file;
      if( file == null){
        this.inputs.fileSingle = null;
        this.readerpdf="";
        return;
      }
      const self = this;
      this.inputs.fileSingle = file;
      var reader = new FileReader();
      reader.readAsDataURL(this.inputs.fileSingle);
      reader.onload = () => {
        console.log(reader.result);
        self.readerpdf = reader.result
         self.filedata={
            'docname':'cert1111.p12',
            'p12file': self.readerpdf.split(',')[1]
      };
      self.canshowbutton=true
    //  self.uploadcertfile(filedata);
    };


    },

uploadcertfile() {
  var currid='';
  const self = this;
  var filexdata = this.filedata;   
  this.isLoading =true;
  return axios
  .post('https://portafirmasservice-dot-groupchrono2015.appspot.com' + '/api/portafirmas/uploadcertificate/', filexdata)
  .then(response => {
    if (response.data) {
            console.log(response.data);

            currid=response.data;

             axios
  .get('https://portafirmasservice-dot-groupchrono2015.appspot.com' + '/api/portafirmas/tempcertificate/' + currid)
  .then(response => {
    if (response.data) {
            console.log(response.data);

            self.urlfile=response.data.certfile;
            self.canshowqr=true;
            self.isLoading=false;
    }
            self.isLoading=false;

    return response.data;
  });

    }


    return response.data;
  });
}
  }
  }
</script>

<style>
  #drop1 {
    height: 200px;
    padding: 40px;
    color: black;
    background: lightblue;
  }

  #drop1 .dz-preview {
    align-content: center;
  }

  #drop1 .dz-success-mark {
    visibility: hidden;
  }  

    #drop1 .dz-error-mark {
    visibility: hidden;
  }  
  /* ... */
</style>
